module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-hairmake-a0f114e95b06460f488ddbee57c984b3.png";